export const INPUT_TYPES = {
  PHONE: 'phone',
  EMAIL: 'email',
}
